import { QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter, Navigate, Outlet, Route, Routes } from 'react-router'
import { SesionProvider } from './auth/SesionProvider'
import { AppShell } from './componentes/AppShell'
import { Agendamiento } from './paginas/Agendamiento'
import { Avisos } from './paginas/Avisos'
import { Calendario } from './paginas/Calendario'
import { Conversaciones } from './paginas/Conversaciones'
import { Login } from './paginas/Login'
import { Logistica } from './paginas/Logistica'
import { Workflows } from './paginas/Workflows'
import { ConfirmarAgendamiento } from './paginas/ConfirmarAgendamiento'
import { Recalculo } from './paginas/Recalculo'
import { Incidencias } from './paginas/Incidencias'
import { Auditoria } from './paginas/Auditoria'
import { GrandesEmpresas } from './paginas/GrandesEmpresas'
import { Clientes } from './paginas/Clientes'
import { Catalogo } from './paginas/Catalogo'
import { Albaranes } from './paginas/Albaranes'
import { RutaDelDia } from './paginas/RutaDelDia'
import { AvisoSemanal } from './paginas/AvisoSemanal'
import { Usuarios } from './paginas/Usuarios'
import { Ajustes } from './paginas/Ajustes'
import { RutaProtegida } from './rutas/RutaProtegida'
import { ProveedorTema } from './tema/ProveedorTema'
import { ApiProvider, crearClienteConsultas } from './api/contexto'

// La politica de reintentos vive junto al cliente de API porque depende de
// `ErrorApi`; aqui solo se instancia una vez para toda la aplicacion.
const clienteConsultas = crearClienteConsultas()

export function App() {
  return (
    // El proveedor de tema envuelve a todo, y no solo al armazon: el login
    // tambien se pinta en el tema elegido, que es la primera pantalla que se ve.
    <ProveedorTema>
      <QueryClientProvider client={clienteConsultas}>
        <SesionProvider>
          <ApiProvider>
            <BrowserRouter>
              <Routes>
                <Route path="/login" element={<Login />} />
                <Route element={<RutaProtegida />}>
                  <Route
                    element={
                      <AppShell>
                        <Outlet />
                      </AppShell>
                    }
                  >
                    <Route path="/logistica" element={<Logistica />} />
                    <Route path="/clientes" element={<Clientes />} />
                    <Route path="/catalogo" element={<Catalogo />} />
                    {/* Dos rutas explicitas en vez de `/conversaciones/:seccion`:
                        solo hay dos secciones, son las que enlaza el shell, y asi
                        no existe el caso de un parametro inventado. */}
                    <Route
                      path="/conversaciones/clientes"
                      element={<Conversaciones seccion="clientes" />}
                    />
                    <Route
                      path="/conversaciones/leads"
                      element={<Conversaciones seccion="leads" />}
                    />
                    <Route path="/avisos" element={<Avisos />} />
                    <Route path="/aviso-semanal" element={<AvisoSemanal />} />
                    <Route path="/confirmar" element={<ConfirmarAgendamiento />} />
                    <Route path="/incidencias" element={<Incidencias />} />
                    <Route path="/auditoria" element={<Auditoria />} />
                    <Route path="/grandes-empresas" element={<GrandesEmpresas />} />
                    <Route path="/agendamiento" element={<Agendamiento />} />
                    <Route path="/albaranes" element={<Albaranes />} />
                    <Route path="/ruta-del-dia" element={<RutaDelDia />} />
                    <Route path="/calendario" element={<Calendario />} />
                    <Route path="/workflows" element={<Workflows />} />
                    <Route path="/recalculo" element={<Recalculo />} />
                    <Route path="/usuarios" element={<Usuarios />} />
                    <Route path="/ajustes" element={<Ajustes />} />
                  </Route>
                </Route>
                <Route path="*" element={<Navigate to="/logistica" replace />} />
              </Routes>
            </BrowserRouter>
          </ApiProvider>
        </SesionProvider>
      </QueryClientProvider>
    </ProveedorTema>
  )
}
